import {
    Component,
    OnInit,
    OnDestroy,
    Output,
    EventEmitter,
    SimpleChanges,
    ChangeDetectionStrategy,
    forwardRef
} from '@angular/core';
import {
    FormGroup,
    FormBuilder,
    FormArray,
    Validator,
    Validators,
    ControlValueAccessor,
    NG_VALUE_ACCESSOR,
    NG_VALIDATORS
} from '@angular/forms';
import { FormHelper, CoreValidators, TranslationService } from '../../core';
import { PricelistShipmentModel } from '../services/pricelist.service';
import { Subscription } from 'rxjs';

export function shipmentGroupValidator() {
    return (c: FormGroup, required: boolean) => {
        return null;
    };
}

@Component({
    template: require('./sm-shipment.component.html'),
    selector: 'sm-shipment',
    // changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => SmShipmentComponent), multi: true },
        { provide: NG_VALIDATORS, useExisting: forwardRef(() => SmShipmentComponent), multi: true }
    ]
})
export class SmShipmentComponent implements Validator, ControlValueAccessor, OnInit, OnDestroy {
    @Output('toggle') onToggle: EventEmitter<boolean> = new EventEmitter();
    form: FormGroup;

    private _validator: Function;
    private _disabled: boolean;
    private _subs: Subscription[] = [];
    private _controlledByCheck = [
        'priceForFirst',
        'priceForOther',
        'amountInPackage'
    ];

    constructor(
        private _fb: FormBuilder,
        private _translations: TranslationService
    ) {
        this._validator = shipmentGroupValidator();
    }

    ngOnInit() {
        this.buildForm();
    }

    ngOnDestroy() {
        this._subs!.forEach(s => s.unsubscribe());
    }

    toggle() {
        this.setDisableOrEnable();
        this.onToggle.emit(this._disabled);
    }

    //#region ControlValueAccessor implementation

    writeValue(obj: any): void {
        if (obj) {
            this.form.patchValue(obj, { onlySelf: true, emitEvent: false });
            this.setDisableOrEnable();
        }
    }

    registerOnChange(fn: any): void {
        this._subs.push(this.form.valueChanges.subscribe(fn));
    }

    registerOnTouched(fn: any): void {
        this.form.statusChanges.subscribe(s => {
            if (this.form.touched) {
                fn(this.form.value);
            }
        });
    }

    setDisabledState(isDisabled: boolean): void {
        FormHelper.toggle(this.form, isDisabled);
        if (!isDisabled) {
            this.setDisableOrEnable();
        }
    }

    getErrorMessageForAmountInPackage(): string {
        return this._translations.getString('Číslo musí být rovno nebo vyšší 1');
    }

    //#endregion ControlValueAccessor implementation

    //#region Validator

    validate(c: FormGroup) {
        if (this.form.valid) {
            return null;
        }

        return {
            smShipment: this.form.errors || c.errors
        };
    }

    //#endregion Validator

    private buildForm() {
        this.form = this._fb.group({
            shipmentType: null,
            shipmentName: null,
            shipmentId: null,
            priceForFirst: [null, [Validators.required, CoreValidators.validateNumber({ min: 0, max: 10000000000, float: true })]],
            priceForOther: [null, [Validators.required, CoreValidators.validateNumber({ min: 0, max: 10000000000, float: true })]],
            isEnabled: false,
            isReadonly: false,
            isFree: false,
            amountInPackage: [null, [Validators.required, CoreValidators.validateNumber({ min: 1, max: 2147483647 })]]
        });

        this.setDisableOrEnable();
    }

    private setDisableOrEnable(disable?: boolean, force?: boolean) {
        if (disable == null) {
            disable = !this.form.value.isEnabled || this.form.value.isReadonly || this.form.value.isFree;
        }

        FormHelper.toggleMore(this._controlledByCheck, this.form, disable);
        this._disabled = disable;
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./app/shared/components/sm-shipment.component.ts